import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { TranslationLanguage } from '../../../../../../graphql/service/graphql-auto-main-service';

@Component({
  selector: 'app-lot-ai-translation-tab',
  templateUrl: './lot-ai-translation-tab.component.html',
  styleUrls: ['./lot-ai-translation-tab.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LotAiTranslationTabComponent {
  @Input() canRequest = false;
  @Input() languages: TranslationLanguage[] = [TranslationLanguage.Ru];
  @Input() language = TranslationLanguage.Ru;

  @Output() languageChange = new EventEmitter<TranslationLanguage>();

  onLanguageChange(language: TranslationLanguage): void {
    this.languageChange.emit(language);
  }
}
